import { render } from "./CommonSpinner.vue?vue&type=template&id=7f7f1a4e"
import script from "./CommonSpinner.vue?vue&type=script&lang=js"
export * from "./CommonSpinner.vue?vue&type=script&lang=js"

import "./CommonSpinner.vue?vue&type=style&index=0&id=7f7f1a4e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__